import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { AlertCircle } from 'lucide-react';
interface DuplicateStoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeName: string;
  onDuplicate: (newStoreName: string) => void;
}
export function DuplicateStoreModal({
  isOpen,
  onClose,
  storeName,
  onDuplicate
}: DuplicateStoreModalProps) {
  const [newStoreName, setNewStoreName] = useState(`${storeName} (Copy)`);
  const handleDuplicate = () => {
    onDuplicate(newStoreName);
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Duplicate Store" size="sm" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-145">
            Cancel
          </Button>
          <Button onClick={handleDuplicate} data-id="element-146">Create Duplicate</Button>
        </>} data-id="element-144">
      <div className="space-y-4" data-id="element-147">
        <div className="flex items-start space-x-3 p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-148">
          <AlertCircle className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-149" />
          <div className="text-sm text-blue-800" data-id="element-150">
            <p className="font-medium mb-1" data-id="element-151">This will create a copy of:</p>
            <ul className="list-disc list-inside space-y-1 text-xs" data-id="element-152">
              <li data-id="element-153">Store settings and schedule</li>
              <li data-id="element-154">Products and bundles</li>
              <li data-id="element-155">Access controls</li>
              <li data-id="element-156">Checkout configuration</li>
            </ul>
            <p className="mt-2 text-xs italic" data-id="element-157">
              Orders and performance data will not be copied.
            </p>
          </div>
        </div>

        <Input label="New Store Name" value={newStoreName} onChange={e => setNewStoreName(e.target.value)} placeholder="Enter name for duplicated store" data-id="element-158" />
      </div>
    </Modal>;
}